import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';


export interface JcCheckboxProps extends JcCommonProps {
  readonly label: React.ReactNode;
  readonly value: boolean;
  readonly onClick: (clicked: boolean) => void;
  readonly disabled?: boolean;
}


export const JcCheckbox: React.FunctionComponent<JcCheckboxProps> = (props: JcCheckboxProps) => {

  // The id belongs on the input itself, so keep it off the wrapping label.
  const { label, value, onClick, disabled, id, ...otherCommonProps } = props;
  const commonProps = JcUtils.commonProps(otherCommonProps, ["jc-checkbox", disabled && "jc-disabled"]);
  const inputId = useJcFieldId(id);

  // A <label> wrapper makes the whole control (input + label) clickable — clicking
  // the label toggles the checkbox natively.
  return <label {...commonProps}>
    <input
      id={inputId}
      type="checkbox"
      checked={value}
      disabled={disabled}
      onChange={() => onClick(!value)}
    />
    {label}
  </label>
}